import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'adm-modal-help',
  templateUrl: './modal-help.component.html',
  styleUrl: './modal-help.component.scss',
  imports: [CommonModule, MatDialogModule, MatIconModule],
})
export class ModalHelpComponent implements OnInit {
  dialogRef = inject<MatDialogRef<ModalHelpComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  public title = '';
  public text = '';

  ngOnInit() {
    this.title = this.data?.title;
    this.text = this.data?.text;
  }
  close(refresh: boolean) {
    this.dialogRef.close(refresh);
  }
}
